<template xmlns="http://www.w3.org/1999/html">
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <label class="label">E-mail</label>
          <p class="control">
            <input v-model="profile.username" class="input" type="text" v-bind:disabled="true">
          </p>
          <label class="label">Идентификатор пользователя</label>
          <p class="control">
            <input v-model="profile.id" class="input" type="text" v-bind:readonly="true">
          </p>
          <label class="label">Тип</label>
          <p class="control">
              <span class="select">
                <select v-model="profile.roleId" :disabled="!canEdit()">
                  <option value="1">Администратор</option>
                  <option value="2">Партнер</option>
                  <option value="4">Реферер</option>
                  <option value="8">Клиент</option>
                </select>
              </span>
          </p>
          <label class="label">Статус</label>
          <p class="control">
              <span class="select">
                <select v-model="profile.state" :disabled="!canEdit()">
                  <option value="FILL_PROFILE">Заполните личную карточку</option>
                  <option value="SIGN_CONTRACT">Ожидаем подписания договора</option>
                  <option value="REFILL_BALANCE">Нужно пополнить баланс</option>
                  <option value="ACTIVE">Активен</option>
                </select>
              </span>
          </p>
            <label class="label">ФИО</label>
            <p class="control">
              <input v-model="profile.fullname" class="input" type="text">
            </p>
            <label class="label">Часовой пояс (UTC)</label>
            <p class="control">
              <span class="select">
                <select v-model="profile.timeZone">
                  <option>0</option>
                  <option>+1</option>
                  <option>+2</option>
                  <option>+3</option>
                  <option>+4</option>
                  <option>+5</option>
                  <option>+6</option>
                  <option>+7</option>
                  <option>+8</option>
                  <option>+9</option>
                  <option>+10</option>
                  <option>+11</option>
                  <option>+12</option>
                </select>
              </span>
            </p>
            <label class="label">Телефон</label>
            <p class="control">
              <input v-model="profile.phone" class="input" type="text">
            </p>
            <label class="label">ИНН</label>
            <p class="control">
              <input v-model="profile.INN" class="input" type="text">
            </p>
            <label class="label">Адрес</label>
            <p class="control">
              <input v-model="profile.address" class="input" type="text">
            </p>
            <label class="label">Паспорт</label>
            <p class="control">
              <input v-model="profile.passport" class="input" type="text">
            </p>
            <label class="label">Вид деятельности</label>
            <p class="control">
              <input v-model="profile.businessType" class="input" type="text">
            </p>
            <label class="label">Менеджер</label>
            <p class="control">
              <input v-model="profile.manager" class="input" type="text">
            </p>
            <label class="label">Тариф</label>
            <p class="control">
              <input v-model="profile.tariff" class="input" type="text">
            </p>
            <p class="control">
              <input class="button is-info" type="button" id="uploadFile" value="Загрузить скан договора (pdf, jpg, png; до 10 Мб)" onclick="document.getElementById('uploadContract').click();">
              <input style="display:none;" @input="uploadContract('uploadContract')" :id="`uploadContract`" name="load-contract" type="file" accept=".jpg,.png,.pdf">
              <a  v-if="profile.contractName!=''" :href="'/api/profiles/contract?userId=' + this.$props.id"  tag="button">
                <button class="button is-info">
                  <span class="icon">
                    <i class="fa fa-download"></i>
                  </span>
                  <span>Просмотр договора</span>
                </button>
              </a>
            </p>


            <button class="button is-primary" v-on:click="save">
              <span class="icon">
                <i class="fa fa-floppy-o"></i>
              </span>
              <span>Сохранить</span>
            </button>
            <button class="button is-light" v-on:click="cancel">
              <span class="icon">
                <i class="fa fa-times-circle"></i>
              </span>
              <span>Закрыть</span>
            </button>
        </article>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Notification from 'vue-bulma-notification'
import Cleave from 'vue-cleave'

const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}

const PROFILES_API = '/api/profiles'

export default {
  props: ['id'],
  components: {
    Cleave,
    Notification
  },
  data () {
    return {
      profile: {},
      isSaved: false
    }
  },
  created: function () {
    this.handleProfile()
  },
  computed: {
    ...mapGetters([
      'authenticationToken',
      'loggedRole',
      'loggedId'
    ])
  },
  methods: {
    prepareSecurityHeader() {
      console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      }
    },
    save () {
      if (this.profile.id === undefined) {
        this.saveNew()
      } else {
        this.update()
      }
    },
    saveNew () {
//      if (this.user.username != '') {
//        if (this.reg.test(this.user.username)) {
          console.log('saving new profile: ' + JSON.stringify(this.profile))
          this.$http.post(PROFILES_API, this.profile, {headers: this.prepareSecurityHeader()})
            .then((response) => {
              if (response.data != '') {
                console.log(response.data)
                this.isSaved = true
                this.profile = response.data
                this.openNotificationWithType('info', 'Профиль сохранен.')
//                this.$router.push('/users/')
              } else {
                console.log('Already exist')
                this.openNotificationWithType('danger', 'Такой профиль уже существует.')
              }
            }).catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка сохранения данных')
          })
//        } else {
//          errorMessage = 'Необходимо ввести корректный адрес электронной почты'
//        }
//      } else {
//        errorMessage = 'Необходимо ввести адрес электронной почты'
//      }
    },
    update () {
//      if (this.user.username != '') {
//        if (this.reg.test(this.user.username)) {
          console.log('updating profile: ' + JSON.stringify(this.profile))
          this.$http.put(PROFILES_API, this.profile, {headers: this.prepareSecurityHeader()})
            .then((response) => {
              this.isSaved = true
              console.log(response.data)
              this.openNotificationWithType('info', 'Профиль сохранен.')
//              this.$router.push('/users/')
            }).catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка сохранения данных')
          })
//        } else {
//          errorMessage = 'Необходимо ввести корректный адрес электронной почты'
//        }
//      } else {
//        errorMessage = 'Необходимо ввести адрес электронной почты'
//      }
    },
    handleProfile () {
      if (this.$props.id) {
        console.log('loading profile: ' + this.profile.username)
        this.loadProfile()
      } else {
        console.log('creating new profile')
        this.notSaved()
        return {}
      }
    },
    loadProfile () {
      this.$http({
        url: PROFILES_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        this.profile = response.data
        this.isSaved = true
      }).catch((error) => {
        console.log(error)
      })
    },
    uploadContract(inputId) {
      const input = document.querySelector(`#${inputId}`)
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить профиль')
        } else {
          if (input.files[0].size > 10 * 1024 * 1024) {
            this.openNotificationWithType('danger', 'Слишком большой файл (> 10 Мб)')
          } else {
            this.handleUploadContractRequest(input.files[0])
          }
        }
      }
    },
    handleUploadContractRequest (contractFile) {
      this.$http.post(PROFILES_API + '/' + 'loadContract', this.prepareMultipartFile(contractFile, this.$props.id), this.prepareSecurityHeader())
        .then(response => {
          console.log(response)
          if (response.status == 200) {
              this.openNotificationWithType('info', 'Файл загружен.')
              // this.loadTasksCount()
            this.loadProfile()
          } else {
            this.openNotificationWithType('danger', 'Ошибка загрузки файла')
            // this.loadTasksCount()
          }
        })
        .catch(error => {
          this.openNotificationWithType('danger', 'Ошибка загрузки файла')
          // this.loadTasksCount()
          console.log(error)
        })
      // this.loadTasksCountPerformed()
    },
    prepareMultipartFile (contractFile, userId) {
      const contractFormData = new FormData()
      contractFormData.append('file', contractFile)
      contractFormData.append('id', userId)
      return contractFormData
    },
    openNotificationWithType (type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      })
    },
    notSaved () {
      this.isSaved = false
    },
    canEdit() {
      return (this.loggedRole == 1)
    },
    cancel () {
      this.$router.push('/users/' + this.$props.id)
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../../node_modules/bulma/sass/utilities/mixins';

.time {
  margin: 0px 10px;
}

</style>



// WEBPACK FOOTER //
// Profile.vue?499efb80